// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

const createGridApi = (state, action) => action.gridApi;

export default (state = {}, action) => {

    const actionTypes = {
        [actions.CREATE_AG_GRID_API]: createGridApi
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/shared/reducers/grid-api.js